module.exports = __webpack_public_path__ + "static/media/00.c6374cf9.png";